export default "__VITE_ASSET__DsL0Z5Br__"